import React from 'react'
export function toUpperKey(obj) {
    let newObj = {}
    for (let key in obj) {
        newObj[`${key[0].toUpperCase()}${key.substr(1)}`] = obj[key]
    }

    return newObj
}